export default [
    {
        path: '/company/corpstandart/:id',
        name: 'Corpstandart',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/corpstandart/corpstandart.vue'),
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/company/corpstandart/:id/type_of_work/new',
        name: 'NewTypeOfWork',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/corpstandart/new_type_of_work.vue'),
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/company/corpstandart/:id/type_of_work/:id_skill/edit',
        name: 'EditTypeOfWork',
        props: true,
        component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/corpstandart/edit_type_of_work.vue'),
        meta: { 
        requiresAuth: true
        }
    },    
]